import { profileGuard } from './profileGuard.directive.js';
import { permissionGuard } from './permission-guard.directive.js';
import { glSkeletor } from './skeletor.directive.js';

const directives = {
  // ugly hack, but profile-guard is not a name that
  // can be exported due to the hyphen
  'profile-guard': profileGuard['profile-guard'],
  'permission-guard': permissionGuard['permission-guard'],
  skeletor: glSkeletor['skeletor']
};

export { directives };
